import { useState , useEffect} from 'react';
import webapi from '../../../api/webapi';
import '../../css/style.css';

const SurfResultParagraphSelectBar = (props) => {
    
    const [item,setItem] = useState('');
    const [paragraphSequenceList,setParagraphSequenceList]=useState(undefined);


    useEffect(() => {
        props.setItem('');
        async function UpdateParagraphSequenceList() {
            props.setLoadingShow(true)
            await webapi.get('surf/chaptersparagraph/' + props.selectedChapter)
                .then(response => {
                    
                    setParagraphSequenceList(response.data);
                    if  (response.data && response.data.length===1)
                    {   
                        setItem(response.data[0].Code)
                        props.setItem(response.data[0].Code)
                    }
                    else
                        if  (response.data && response.data.length>1)
                        {
                            setItem('All')
                            props.setItem('All')
                        }
                })
            
            props.setLoadingShow(false)
        }
        UpdateParagraphSequenceList();
    }, [props.selectedChapter]);

    // componentDidUpdate() {
    //     if ((this.props.selectedBook)&&(this.props.selectedChapter)&&(this.props.selectedChapter!==this.state.SelectedChapter))
    //     {
    //         this.setState({ selectedChapter : this.props.selectedChapter },()=>{this.UpdateParagraphSequenceList();});
    //     }
    //  }
     
    const onTextChange = event=> {
        setItem(event.target.value);
        props.setItem(event.target.value)
    }

    const onTextKeyPress = event => {
        if (event.nativeEvent.key === "Enter" && item) {
            event.preventDefault();
            props.onSearchButtonClick(event);
        }
    }
    return (
        <div className="fullwidth_div">
            <br />
            <select style={{width:'calc(50% - 30px)',direction:'inherit',margin:'0px 15px',marginRight: '25%',marginTop: '15px', float: 'right'}}
                id="item" 
                type="text" 
                className=""
                required="required" 
                value={item || ''} 
                onChange={onTextChange}
                onKeyPress={onTextKeyPress}
            >  
                {   
                    ( paragraphSequenceList && paragraphSequenceList !== undefined)
                    ?
                    (paragraphSequenceList.map((paragraphSequence,i) =>
                        {
                            return  (
                                (i===0)
                                ?
                                (
                                    [
                                        <option key={paragraphSequence.Code+"-1"} value={"All"} select="true">{props.pageData.length!==0 && props.pageData[0].F29902!== undefined ? props.pageData[0].F29902:29902/*همه*/}</option>
                                        ,
                                        <option key={paragraphSequence.Code} value={paragraphSequence.Code}>{paragraphSequence.Title}</option> 
                                    ]
                                )
                                :
                                (
                                    <option key={paragraphSequence.Code} value={paragraphSequence.Code}>{paragraphSequence.Title}</option> 
                                )
                            )
                        })
                    )
                    :
                    <option value="-1">-</option>       
                }                
            </select>
        </div>
    );
}

export default SurfResultParagraphSelectBar;